var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"com-competition-index-wrapper"},[_c(_setup.CsiCompetitionIndex,{attrs:{"csi-index":_setup.csiIndex}}),_c(_setup.ScoreCompetitionIndex,{attrs:{"score-index":_setup.scoreIndex}}),_c(_setup.FavorableRateCompetitionIndex,{attrs:{"favorable-rate-index":_setup.favorableRateIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }